module.exports = __webpack_public_path__ + "static/cirque-du-freak-the-saga-of-darren-shan-book-1-9b04e949276d83a6d414768f3e6ba21e.jpg";